export default "__VITE_ASSET__KLw6Cns9__"